import api from './axios';

export const saveReview = async (review_id, template_id, form_values, review_status) => {
  try {
    const response = await api.post(`/reviews/${review_id}?template_id=${template_id}`, {
      form_values: form_values,
      review_status: review_status,
    });
    console.log(response);
  } catch (error) {
    console.error('saveReview failed', error);
    throw error;
  }
};
